import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Paper,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Slider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Collapse,
  Alert,
  Switch,
  Radio,
  RadioGroup,
  FormLabel,
  FormGroup,
  Autocomplete,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Badge,
  Tooltip,
  useTheme,
  useMediaQuery,
  Drawer,
  alpha,
  styled,
} from '@mui/material';
import {
  ExpandMore,
  ExpandLess,
  FilterList,
  Clear,
  Search,
  LocationOn,
  Star,
  AccessTime,
  Language,
  Psychology,
  Payment,
  Schedule,
  Person,
  VideoCall,
  Phone,
  Refresh,
  TrendingUp,
  TrendingDown,
  CheckCircle,
  Cancel,
  Info,
  Warning,
  Error,
  Help,
  Close,
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  FirstPage,
  LastPage,
  NavigateNext,
  NavigateBefore,
  MoreVert,
  MoreHoriz,
  FilterAlt,
  Sort,
  ViewList,
  ViewModule,
  GridView,
  List as ListIcon,
  Map,
  MyLocation,
  GpsFixed,
  GpsOff,
  Notifications,
  NotificationsOff,
  Settings as SettingsIcon,
  Help as HelpIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Add,
  Remove,
  Clear as ClearIcon,
  Settings, // Added for JSX icon usage
  Work,     // Added for JSX icon usage
  Done,
  Edit,
  Delete,
  Save,
  Download,
  Upload,
  Print,
  Send,
  Reply,
  Forward,
  Archive,
  Unarchive,
  MarkEmailRead,
  MarkEmailUnread,
  Drafts,
  Inbox,
  Outbox,
  Sent,
  Trash,
  Spam,
  Label,
  Folder,
  FolderOpen,
  FolderSpecial,
  Cloud,
  CloudUpload,
  CloudDownload,
  CloudSync,
  CloudOff,
  Wifi,
  WifiOff,
  SignalCellular4Bar,
  SignalCellularConnectedNoInternet4Bar,
  SignalCellularNoSim,
  SignalCellularNull,
  SignalCellularOff,
  SignalWifi4Bar,
  SignalWifiConnectedNoInternet4Bar,
  SignalWifiOff,
  SignalWifiStatusbar4Bar,
  SignalWifiStatusbarConnectedNoInternet4Bar,
  SignalWifiStatusbarNull,
  Battery20,
  Battery30,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatteryFull,
  BatteryChargingFull,
  BatteryStd,
  BatteryUnknown,
  Brightness4,
  Brightness5,
  Brightness6,
  Brightness7,
  BrightnessAuto,
  BrightnessHigh,
  BrightnessLow,
  BrightnessMedium,
  ScreenRotation,
  ScreenShare,
  StopScreenShare,
  Cast,
  CastConnected,
  CastForEducation,
  Computer,
  DesktopMac,
  DesktopWindows,
  DeveloperBoard,
  DeviceHub,
  Devices,
  Dock,
  Gamepad,
  Headset,
  HeadsetMic,
  Keyboard,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardBackspace,
  KeyboardCapslock,
  KeyboardHide,
  KeyboardReturn,
  KeyboardTab,
  KeyboardVoice,
  Laptop,
  LaptopChromebook,
  LaptopMac,
  LaptopWindows,
  Memory,
  Mouse,
  PhoneAndroid,
  PhoneIphone,
  Phonelink,
  PhonelinkOff,
  Router,
  Scanner,
  Security,
  SimCard,
  Smartphone,
  Speaker,
  SpeakerGroup,
  Tablet,
  TabletAndroid,
  TabletMac,
  Toys,
  Tv,
  VideogameAsset,
  Watch,
  WatchLater,
  AccessTimeFilled,
  Accessible,
  AccessibleForward,
  AccountBalance,
  AccountBalanceWallet,
  AccountBox,
  AccountCircle,
  AddShoppingCart,
  Alarm,
  AlarmAdd,
  AlarmOff,
  AlarmOn,
  AllInbox,
  AllOut,
  Android,
  Announcement,
  AspectRatio,
  Assessment,
  Assignment,
  AssignmentInd,
  AssignmentLate,
  AssignmentReturn,
  AssignmentReturned,
  AssignmentTurnedIn,
  Autorenew,
  Backup,
  Book,
  BookOnline,
  Bookmark,
  BookmarkBorder,
  BugReport,
  Build,
  Cached,
  CalendarToday,
  CameraEnhance,
  CardGiftcard,
  CardMembership,
  CardTravel,
  ChangeHistory,
  CheckCircle as CheckCircleIcon2,
  ChromeReaderMode,
  Class,
  Code,
  Commute,
  CompareArrows,
  ContactSupport,
  Copyright,
  CreditCard,
  Dashboard,
  Delete as DeleteIcon,
  Description,
  Dns,
  Done as DoneIcon,
  DoneAll,
  DonutLarge,
  DonutSmall,
  DragIndicator,
  Eco,
  EuroSymbol,
  Event,
  EventSeat,
  ExitToApp,
  Explore,
  Extension,
  Face,
  Favorite,
  FavoriteBorder,
  Feedback,
  FindInPage,
  FindReplace,
  Fingerprint,
  FlightLand,
  FlightTakeoff,
  FlipToBack,
  FlipToFront,
  GTranslate,
  Gavel,
  GetApp,
  Gif,
  Grade,
  GroupWork,
  Help as HelpIcon2,
  HelpOutline,
  HighlightOff,
  History,
  Home,
  HorizontalSplit,
  HourglassEmpty,
  HourglassFull,
  Http,
  Https,
  ImportantDevices,
  Info as InfoIcon2,
  InfoOutline,
  Input,
  InvertColors,
  Label as LabelIcon,
  LabelImportant,
  LabelOff,
  Language as LanguageIcon,
  Launch,
  LineStyle,
  LineWeight,
  List as ListIcon2,
  Lock,
  LockOpen,
  Loyalty,
  MarkunreadMailbox,
  Maximize,
  Minimize,
  Motorcycle,
  NoteAdd,
  OfflineBolt,
  OfflinePin,
  Opacity,
  OpenInBrowser,
  OpenInNew,
  OpenWith,
  Pageview,
  PanTool,
  Payment as PaymentIcon,
  PermCameraMic,
  PermContactCalendar,
  PermDataSetting,
  PermDeviceInformation,
  PermIdentity,
  PermMedia,
  PermPhoneMsg,
  PermScanWifi,
  Pets,
  PictureInPicture,
  PictureInPictureAlt,
  PlayForWork,
  Polymer,
  PowerSettingsNew,
  PregnantWoman,
  Print as PrintIcon,
  QueryBuilder,
  QuestionAnswer,
  Receipt as ReceiptIcon,
  RecordVoiceOver,
  Redeem,
  RemoveShoppingCart,
  Reorder,
  ReportProblem,
  Restore,
  RestoreFromTrash,
  RestorePage,
  Room,
  RoundedCorner,
  Rowing,
  Schedule as ScheduleIcon,
  Search as SearchIcon,
  Settings as SettingsIcon2,
  SettingsApplications,
  SettingsBackupRestore,
  SettingsBluetooth,
  SettingsBrightness,
  SettingsCell,
  SettingsEthernet,
  SettingsInputAntenna,
  SettingsInputComponent,
  SettingsInputComposite,
  SettingsInputHdmi,
  SettingsInputSvideo,
  SettingsOverscan,
  SettingsPhone,
  SettingsPower,
  SettingsRemote,
  SettingsVoice,
  Shop,
  ShopTwo,
  ShoppingBasket,
  ShoppingCart,
  SpeakerNotes,
  SpeakerNotesOff,
  Spellcheck,
  StarRate,
  Stars,
  Store,
  Subject,
  SupervisedUserCircle,
  SupervisorAccount,
  SwapHoriz,
  SwapVert,
  SwapVerticalCircle,
  SystemUpdateAlt,
  Tab,
  TabUnselected,
  Theaters,
  ThreeDRotation,
  ThumbDown as ThumbDownIcon,
  ThumbUp as ThumbUpIcon,
  ThumbsUpDown,
  Timeline,
  Toc,
  Today,
  Toll,
  TrackChanges,
  Translate,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon,
  TurnedIn,
  TurnedInNot,
  Update,
  VerifiedUser,
  VerticalSplit,
  ViewAgenda,
  ViewArray,
  ViewCarousel,
  ViewColumn,
  ViewDay,
  ViewHeadline,
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon,
  ViewQuilt,
  ViewStream,
  ViewWeek,
  Visibility,
  VisibilityOff,
  VoiceOverOff,
  WatchLater as WatchLaterIcon,
  Work as WorkIcon,
  WorkOff,
  WorkOutline,
  YoutubeSearchedFor,
  ZoomIn,
  ZoomOut,
  Chat,
  Support,
} from '@mui/icons-material';

const StyledFilterPanel = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  background: theme.palette.background.paper,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&:before': {
    display: 'none',
  },
  boxShadow: 'none',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  borderRadius: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  transition: 'all 0.2s ease',
  '&.Mui-expanded': {
    margin: theme.spacing(1.5, 0),
    borderColor: alpha(theme.palette.primary.main, 0.3),
    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.1)}`,
  },
  '&:hover': {
    borderColor: alpha(theme.palette.primary.main, 0.2),
    transform: 'translateY(-1px)',
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  '& .MuiAccordionSummary-content': {
    margin: theme.spacing(1.5, 0),
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.primary.main,
    transition: 'transform 0.2s ease',
  },
  '&.Mui-expanded .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(180deg)',
  },
}));

const FilterPanel = ({
  filters,
  onChange,
  isMobile,
  isOpen,
  onClose,
  selectedSpecialties,
  setSelectedSpecialties,
  priceRange,
  setPriceRange,
  experienceRange,
  setExperienceRange,
  availabilityFilter,
  setAvailabilityFilter,
  languageFilter,
  setLanguageFilter,
  genderFilter,
  setGenderFilter,
  consultationType,
  setConsultationType,
  showAdvancedFilters,
  setShowAdvancedFilters,
  specialties = [],
  languages = [],
  onFilterChange, // New prop for immediate filter updates
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // Local state for filter management
  const [expandedAccordion, setExpandedAccordion] = useState('specialties');
  const [showMoreSpecialties, setShowMoreSpecialties] = useState(false);
  const [showMoreLanguages, setShowMoreLanguages] = useState(false);
  const [searchSpecialty, setSearchSpecialty] = useState('');
  const [searchLanguage, setSearchLanguage] = useState('');

  // Memoized filtered results for better performance
  const filteredSpecialties = useMemo(() => 
    specialties.filter(specialty =>
      specialty.toLowerCase().includes(searchSpecialty.toLowerCase())
    ), [specialties, searchSpecialty]
  );

  const filteredLanguages = useMemo(() => 
    languages.filter(language =>
      language.toLowerCase().includes(searchLanguage.toLowerCase())
    ), [languages, searchLanguage]
  );

  // Filter data
  const ratingOptions = [
    { value: 4, label: '4+ Stars', icon: Star },
    { value: 3, label: '3+ Stars', icon: Star },
    { value: 2, label: '2+ Stars', icon: Star },
  ];

  const availabilityOptions = [
    { value: 'all', label: 'All', icon: Schedule },
    { value: 'today', label: 'Today', icon: Today },
    { value: 'tomorrow', label: 'Tomorrow', icon: NavigateNext },
    { value: 'this_week', label: 'This Week', icon: ViewWeek },
    { value: 'next_week', label: 'Next Week', icon: CalendarToday },
  ];

  const genderOptions = [
    { value: 'all', label: 'All', icon: Person },
    { value: 'male', label: 'Male', icon: Person },
    { value: 'female', label: 'Female', icon: Person },
  ];

  const consultationTypeOptions = [
    { value: 'all', label: 'All Types', icon: Settings },
    { value: 'video', label: 'Video Call', icon: VideoCall },
    { value: 'phone', label: 'Phone Call', icon: Phone },
    { value: 'in_person', label: 'In Person', icon: Person },
    { value: 'chat', label: 'Chat', icon: Chat },
  ];

  const distanceOptions = [
    { value: 5, label: '5 km' },
    { value: 10, label: '10 km' },
    { value: 15, label: '15 km' },
    { value: 20, label: '20 km' },
    { value: 50, label: '50 km' },
  ];

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);
  };

  const handleSpecialtyToggle = (specialty) => {
    const newSpecialties = selectedSpecialties.includes(specialty)
      ? selectedSpecialties.filter(s => s !== specialty)
      : [...selectedSpecialties, specialty];
    
    setSelectedSpecialties(newSpecialties);
    
    // Call the parent's filter change handler for immediate updates
    if (onFilterChange) {
      onFilterChange('speciality', newSpecialties.join(','));
    }
  };

  const handleLanguageToggle = (language) => {
    const newLanguages = languageFilter.includes(language)
      ? languageFilter.filter(l => l !== language)
      : [...languageFilter, language];
    
    setLanguageFilter(newLanguages);
    
    // Call the parent's filter change handler for immediate updates
    if (onFilterChange) {
      onFilterChange('language', newLanguages.join(','));
    }
  };

  const handleClearAllFilters = () => {
    onChange('query', '');
    onChange('location', '');
    onChange('speciality', '');
    onChange('language', '');
    onChange('rating', null);
    onChange('distance', 10);
    setSelectedSpecialties([]);
    setPriceRange([0, 5000]);
    setExperienceRange([0, 30]);
    setAvailabilityFilter('all');
    setLanguageFilter([]);
    setGenderFilter('all');
    setConsultationType('all');
    
    // Call parent's clear filters handler
    if (onFilterChange) {
      onFilterChange('clear', null);
    }
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (filters.query) count++;
    if (filters.location) count++;
    if (filters.speciality) count++;
    if (filters.language) count++;
    if (filters.rating) count++;
    if (filters.distance !== 10) count++;
    if (selectedSpecialties.length > 0) count++;
    if (priceRange[0] !== 0 || priceRange[1] !== 5000) count++;
    if (experienceRange[0] !== 0 || experienceRange[1] !== 30) count++;
    if (availabilityFilter !== 'all') count++;
    if (languageFilter.length > 0) count++;
    if (genderFilter !== 'all') count++;
    if (consultationType !== 'all') count++;
    return count;
  };

  const filterPanelContent = (
    <StyledFilterPanel>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
          <FilterList sx={{ mr: 1 }} />
          Filters
          {getActiveFilterCount() > 0 && (
            <Badge
              badgeContent={getActiveFilterCount()}
              color="primary"
              sx={{ ml: 1 }}
            />
          )}
        </Typography>
        <Button
          size="small"
          startIcon={<Clear />}
          onClick={handleClearAllFilters}
          disabled={getActiveFilterCount() === 0}
        >
          Clear All
        </Button>
      </Box>

      {/* Specialties Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'specialties'}
        onChange={handleAccordionChange('specialties')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Psychology sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Specialties
            </Typography>
            {selectedSpecialties.length > 0 && (
              <Badge badgeContent={selectedSpecialties.length} color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <TextField
            fullWidth
            size="small"
            placeholder="Search specialties..."
            value={searchSpecialty}
            onChange={(e) => setSearchSpecialty(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2 }}
          />
          <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
            {filteredSpecialties.slice(0, showMoreSpecialties ? undefined : 8).map((specialty) => (
              <FormControlLabel
                key={specialty}
                control={
                  <Checkbox
                    checked={selectedSpecialties.includes(specialty)}
                    onChange={() => handleSpecialtyToggle(specialty)}
                    size="small"
                  />
                }
                label={specialty}
                sx={{ display: 'block', mb: 0.5 }}
              />
            ))}
          </Box>
          {filteredSpecialties.length > 8 && (
            <Button
              size="small"
              onClick={() => setShowMoreSpecialties(!showMoreSpecialties)}
              sx={{ mt: 1 }}
            >
              {showMoreSpecialties ? 'Show Less' : `Show ${filteredSpecialties.length - 8} More`}
            </Button>
          )}
        </AccordionDetails>
      </StyledAccordion>

      {/* Rating Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'rating'}
        onChange={handleAccordionChange('rating')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Star sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Rating
            </Typography>
            {filters.rating && (
              <Badge badgeContent={`${filters.rating}+`} color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <RadioGroup
            value={filters.rating || ''}
            onChange={(e) => onChange('rating', e.target.value ? parseInt(e.target.value) : null)}
          >
            {ratingOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {[...Array(option.value)].map((_, i) => (
                      <Star key={i} sx={{ fontSize: 16, color: 'warning.main' }} />
                    ))}
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      {option.label}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </StyledAccordion>

      {/* Price Range Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'price'}
        onChange={handleAccordionChange('price')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Payment sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Consultation Fee
            </Typography>
            {(priceRange[0] !== 0 || priceRange[1] !== 5000) && (
              <Badge 
                badgeContent={`₹${priceRange[0]}-${priceRange[1]}`} 
                color="primary" 
                sx={{ ml: 1 }} 
              />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <Box sx={{ px: 1 }}>
            <Slider
              value={priceRange}
              onChange={(_, newValue) => setPriceRange(newValue)}
              valueLabelDisplay="auto"
              min={0}
              max={5000}
              step={100}
              valueLabelFormat={(value) => `₹${value}`}
              sx={{ mb: 2 }}
            />
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                label="Min"
                value={priceRange[0]}
                onChange={(e) => setPriceRange([parseInt(e.target.value) || 0, priceRange[1]])}
                InputProps={{
                  startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                }}
              />
              <TextField
                size="small"
                label="Max"
                value={priceRange[1]}
                onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value) || 5000])}
                InputProps={{
                  startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                }}
              />
            </Box>
          </Box>
        </AccordionDetails>
      </StyledAccordion>

      {/* Experience Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'experience'}
        onChange={handleAccordionChange('experience')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Work sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Experience
            </Typography>
            {(experienceRange[0] !== 0 || experienceRange[1] !== 30) && (
              <Badge 
                badgeContent={`${experienceRange[0]}-${experienceRange[1]} years`} 
                color="primary" 
                sx={{ ml: 1 }} 
              />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <Box sx={{ px: 1 }}>
            <Slider
              value={experienceRange}
              onChange={(_, newValue) => setExperienceRange(newValue)}
              valueLabelDisplay="auto"
              min={0}
              max={30}
              step={1}
              valueLabelFormat={(value) => `${value} years`}
              sx={{ mb: 2 }}
            />
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                label="Min Years"
                value={experienceRange[0]}
                onChange={(e) => setExperienceRange([parseInt(e.target.value) || 0, experienceRange[1]])}
              />
              <TextField
                size="small"
                label="Max Years"
                value={experienceRange[1]}
                onChange={(e) => setExperienceRange([experienceRange[0], parseInt(e.target.value) || 30])}
              />
            </Box>
          </Box>
        </AccordionDetails>
      </StyledAccordion>

      {/* Languages Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'languages'}
        onChange={handleAccordionChange('languages')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Language sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Languages
            </Typography>
            {languageFilter.length > 0 && (
              <Badge badgeContent={languageFilter.length} color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <TextField
            fullWidth
            size="small"
            placeholder="Search languages..."
            value={searchLanguage}
            onChange={(e) => setSearchLanguage(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2 }}
          />
          <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
            {filteredLanguages.slice(0, showMoreLanguages ? undefined : 6).map((language) => (
              <FormControlLabel
                key={language}
                control={
                  <Checkbox
                    checked={languageFilter.includes(language)}
                    onChange={() => handleLanguageToggle(language)}
                    size="small"
                  />
                }
                label={language}
                sx={{ display: 'block', mb: 0.5 }}
              />
            ))}
          </Box>
          {filteredLanguages.length > 6 && (
            <Button
              size="small"
              onClick={() => setShowMoreLanguages(!showMoreLanguages)}
              sx={{ mt: 1 }}
            >
              {showMoreLanguages ? 'Show Less' : `Show ${filteredLanguages.length - 6} More`}
            </Button>
          )}
        </AccordionDetails>
      </StyledAccordion>

      {/* Availability Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'availability'}
        onChange={handleAccordionChange('availability')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Schedule sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Availability
            </Typography>
            {availabilityFilter !== 'all' && (
              <Badge badgeContent={availabilityFilter} color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <RadioGroup
            value={availabilityFilter}
            onChange={(e) => {
              const newValue = e.target.value;
              setAvailabilityFilter(newValue);
              if (onFilterChange) {
                onFilterChange('availability', newValue);
              }
            }}
          >
            {availabilityOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <option.icon sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
                    <Typography variant="body2">
                      {option.label}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </StyledAccordion>

      {/* Gender Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'gender'}
        onChange={handleAccordionChange('gender')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Person sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Gender
            </Typography>
            {genderFilter !== 'all' && (
              <Badge badgeContent={genderFilter} color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <RadioGroup
            value={genderFilter}
            onChange={(e) => {
              const newValue = e.target.value;
              setGenderFilter(newValue);
              if (onFilterChange) {
                onFilterChange('gender', newValue);
              }
            }}
          >
            {genderOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <option.icon sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
                    <Typography variant="body2">
                      {option.label}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </StyledAccordion>

      {/* Consultation Type Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'consultation'}
        onChange={handleAccordionChange('consultation')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <VideoCall sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Consultation Type
            </Typography>
            {consultationType !== 'all' && (
              <Badge badgeContent={consultationType} color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <RadioGroup
            value={consultationType}
            onChange={(e) => {
              const newValue = e.target.value;
              setConsultationType(newValue);
              if (onFilterChange) {
                onFilterChange('consultation_type', newValue);
              }
            }}
          >
            {consultationTypeOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <option.icon sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
                    <Typography variant="body2">
                      {option.label}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </StyledAccordion>

      {/* Distance Filter */}
      <StyledAccordion
        expanded={expandedAccordion === 'distance'}
        onChange={handleAccordionChange('distance')}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <LocationOn sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Distance
            </Typography>
            {filters.distance !== 10 && (
              <Badge badgeContent={`${filters.distance} km`} color="primary" sx={{ ml: 1 }} />
            )}
          </Box>
        </StyledAccordionSummary>
        <AccordionDetails>
          <RadioGroup
            value={filters.distance}
            onChange={(e) => onChange('distance', parseInt(e.target.value))}
          >
            {distanceOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </StyledAccordion>

      {/* Advanced Filters Toggle */}
      <Box sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Switch
              checked={showAdvancedFilters}
              onChange={(e) => setShowAdvancedFilters(e.target.checked)}
              size="small"
            />
          }
          label="Advanced Filters"
        />
      </Box>

      {/* Advanced Filters */}
      <Collapse in={showAdvancedFilters}>
        <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
          <Typography variant="body2">
            Advanced filters help you find the perfect match for your specific needs.
          </Typography>
        </Alert>
      </Collapse>
    </StyledFilterPanel>
  );

  // Mobile drawer
  if (isMobile) {
    return (
      <Drawer
        anchor="left"
        open={isOpen}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: '80%',
            maxWidth: 400,
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Filters</Typography>
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
          {filterPanelContent}
        </Box>
      </Drawer>
    );
  }

  // Desktop panel
  return (
    <Box data-testid="filter-panel">
      {filterPanelContent}
    </Box>
  );
};

export default FilterPanel;
